module.exports = __webpack_public_path__ + "img/animation-curves.2df75a7d.gif";